import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getsiteSettingHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "siteSetting", ...action.payload }),
		);
		yield put({
			type: types.GET_SITE_SETTING_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_SITE_SETTING_ERROR,
			payload,
		});
	}
}

export function* getsiteSettingWatcherSaga() {
	yield takeLatest(types.GET_SITE_SETTING_START, getsiteSettingHandlerSaga);
}

//create

//delete

function* deletesiteSettingHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("siteSetting", action.payload),
		);
		yield put({
			type: types.DELETE_SITE_SETTING_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_SITE_SETTING_ERROR,
			payload,
		});
	}
}

export function* deletesiteSettingWatcherSaga() {
	yield takeLatest(
		types.DELETE_SITE_SETTING_START,
		deletesiteSettingHandlerSaga,
	);
}

//update
